import { useDndMonitor } from '@dnd-kit/core';

export type DndMonitorListenersType = Parameters<typeof useDndMonitor>[0];

type DndMonitorProps = Readonly<{
  listeners: DndMonitorListenersType;
}>;

export default function DndMonitor({ listeners }: DndMonitorProps) {
  useDndMonitor(listeners);
  return null;
}
